import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import { App } from './App'
import { store } from './_helpers'
import { CookiesProvider } from 'react-cookie'
import { BrowserRouter as Router } from 'react-router-dom'

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
// antd design
// import 'antd/dist/antd.css'

ReactDOM.render(
    <CookiesProvider>
        <Provider store={store}>
            {/* <Router> */}
                <App />
            {/* </Router> */}
        </Provider>
    </CookiesProvider>,
    document.getElementById('root')
)
